<template>
  <div  ref="searchWrapper" class="phone-search">
    <input
      v-model="searchQuery"
      :placeholder="placeholder"
      class="search-input"
      :type="type"
      @keyup.enter="onEnter"
      @focus="onFocus"
    />

    <ul v-if="showSuggestions && suggestions.length" class="suggestions-list">
      <li
        v-for="(item, index) in suggestions"
        :key="index"
        class="suggestion-item paragraph paragraph--black py_12 px_8"
        @click="selectSuggestion(item)"
      >
          <!-- use scoped slot if provided, fallback to default itemLabel -->
            <slot name="suggestion" :item="item">
            {{ itemLabel(item) }}
            </slot>
      </li>
    </ul>
  </div>
</template>

<script>
import debounce from "lodash.debounce";

export default {
  name: "PhoneSearch",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "Enter phone number",
    },
    type:{
        type:String,
        default: "text"
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    labelKey: {
      type: String,
      default: "phone_number",
    },
    debounceTime: {
      type: Number,
      default: 300, // milliseconds
    },
  },
  data() {
    return {
      searchQuery: this.value,
      showSuggestions: false,
      skipWatch: false,
      isFocused: false,
    };
  },
  watch: {
    value(newVal) {
        this.searchQuery = newVal;
    },
    searchQuery() {
        if (this.skipWatch) {
            this.skipWatch = false; // reset the flag
            return;
        }
      // this.showSuggestions = !!this.searchQuery && this.suggestions.length > 0;
      this.debouncedSearch();
    },
    suggestions(newList) {
      //  react when async data arrives
      this.showSuggestions =
          // !!this.searchQuery && Array.isArray(newList) && newList.length > 0;
          Array.isArray(newList) && newList.length > 0;
      }
  },
  created() {
    this.debouncedSearch = debounce(() => {
      this.$emit("search", this.searchQuery);
    }, this.debounceTime);
  },
  mounted() {
        this.debouncedSearch = debounce(() => {
            this.$emit("search", this.searchQuery);
        }, this.debounceTime);

        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        onEnter() {
            this.$emit("enter", this.searchQuery);
        },
        selectSuggestion(item) {
           const value = this.itemLabel(item);

            // Update internal input
            this.searchQuery = value;
            this.skipWatch = true;

            // Emit v-model update
            this.$emit("update:modelValue", value); // <--- this updates searchPhone in parent

            // Emit select event
            this.$emit("select", item);

            this.showSuggestions = false;
        },
        itemLabel(item) {
            return item[this.labelKey] || item;
        },
        handleClickOutside(event) {
            const wrapper = this.$refs.searchWrapper;
            if (wrapper && !wrapper.contains(event.target)) {
            this.showSuggestions = false;
            this.isFocused = false;
            }
        },
        onFocus() {
          this.isFocused = true;
          if (Array.isArray(this.suggestions) && this.suggestions.length) {
            this.showSuggestions = true;
          }
          if (Array.isArray(this.suggestions) && !this.suggestions.length) {
            // load initial data
            console.log("emitting ent ");
            // this.$emit("enter", this.searchQuery);
            this.$emit("search", this.searchQuery);
          }
        },
    },
};
</script>

<style lang="scss" scoped>
.phone-search {
  position: relative;
  width: 100%;

  .search-input {
    width: 100%;
    padding: 8px 12px;
    font-size: 14px;
    // border: 1px solid #ccc;
    // border-radius: 4px;

    &:focus {
    //   border-color: #0a75f5;
      outline: none;
    //   box-shadow: 0 0 3px #0a75f5;
    }
  }

  .suggestions-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    // border: 1px solid #ccc;
    box-shadow: 0 1px 5px 1px #ccc;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    margin: 0;
    padding: 0;
    list-style: none;

    .suggestion-item {
    //   padding: 8px 12px;
      cursor: pointer;

      &:hover {
        background-color: #f0f0f0;
      }
    }
  }
}
</style>
